import { useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import copy from '~/assets/icons/copy.svg';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { StyledContainer, StyledHint } from './StatsCopyButton.styled';

const StatsCopyButton = ({ onClick }: { onClick: () => void }) => {
	const [hintVisible, setHintVisible] = useState(false);

	return (
		<StyledContainer>
			<Button
				color={ButtonColors.Default}
				height={ButtonHeight.Height30}
				style={{ width: 30 }}
				onMouseEnter={() => setHintVisible(true)}
				onMouseLeave={() => setHintVisible(false)}
				onClick={onClick}
			>
				<img src={copy} />
			</Button>
			<CSSTransition
				in={hintVisible}
				timeout={300}
				classNames={'hint'}
				unmountOnExit
			>
				<StyledHint>
					<Text>Копировать</Text>
				</StyledHint>
			</CSSTransition>
		</StyledContainer>
	);
};

export { StatsCopyButton };
